import React, { useState } from "react";
import styled from "styled-components";
import Modal from "common/Modal";
import NumberInput from "common/NumberInputWithSpinnerState";
import { formats } from "common/constants";

const LabelButton = styled.div`
  cursor: pointer;
  border-radius: 6px;
  background-color: var(--Signal-Blue-Light);
  color: #37abff;
  font-size: 12px;
  line-height: 115%;
  letter-spacing: 0.24px;
  padding: 4px 2px 2px 2px;
  font-family: "AllianceNo2-Light";
  margin: 0 5px;
`;

const WrapperPercentageWarning = styled.div`
  margin: 5px 0 20px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--Text-Primary);
`;

const ThresholdModal = ({
  setDisplayModal,
  metric,
  labelForModal,
  threshold,
  updateThresholds,
  min = -Infinity,
  max = Infinity,
  step = 1,
}) => {
  const [thresholdValue, setThresholdValue] = useState(threshold);
  const doApply = () => {
    updateThresholds(thresholdValue);
    setDisplayModal(null);
  };
  const doClose = () => setDisplayModal(null);

  return (
    <Modal
      title="Thresholds Settings"
      content={() => (
          <NumberInput
            initialValue={threshold}
            name={metric}
            label={`${labelForModal}`}
            onChange={(value) => setThresholdValue(value)}
            min={min}
            max={max}
            step={step}
          />
      )}
      applyLabel="OK"
      onApply={doApply}
      applyDisabled={thresholdValue === threshold || thresholdValue === null}
      closeLabel="CANCEL"
      onClose={doClose}
    />
  );
};

const PercentageWarning = ({
  meanThreshold,
  percentWarning,
  updateThresholds,
}) => {
  const [displayModal, setDisplayModal] = useState(null);

  return (
    <>
      {displayModal === "perecentWarning" ? (
        <ThresholdModal
          setDisplayModal={setDisplayModal}
          metric={"PERCENT-WARNING"}
          labelForModal={"Perecent of worst metrics"}
          threshold={100 - percentWarning}
          updateThresholds={(value) => {
            updateThresholds("PERCENT-WARNING", 100 - value);
          }}
          min={0}
          max={100}
          step={1}
        />
      ) : null}
      {displayModal === "mean" ? (
        <ThresholdModal
          setDisplayModal={setDisplayModal}
          metric={"MEAN-Mbps"}
          labelForModal={"Mean Mbps"}
          threshold={meanThreshold}
          step={0.1}
          updateThresholds={(value) => updateThresholds("MEAN-Mbps", value)}
        />
      ) : null}
      <WrapperPercentageWarning>
        <div>Warn for </div>
        <LabelButton
          onClick={() => {
            setDisplayModal("perecentWarning");
          }}
        >
          {100 - percentWarning}%
        </LabelButton>
        <div>worst metrics, subject to MEAN-Mbps being higher than </div>
        <LabelButton
          onClick={() => {
            setDisplayModal("mean");
          }}
        >
          {formats.oneDecimal(meanThreshold)}
        </LabelButton>
        Mbps.
      </WrapperPercentageWarning>
    </>
  );
};

export default PercentageWarning;